import Isolated from "./isolated";
import ListItem from "./listItem";
import Regular from "./regular";

const Product = {
  Isolated,
  Regular,
  ListItem
};

export default Product;
